

/** @type {import('./reflectApply')} */
module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;




//////////////////
// WEBPACK FOOTER
// ../node_modules/call-bind-apply-helpers/reflectApply.js
// module id = ../node_modules/call-bind-apply-helpers/reflectApply.js
// module chunks = 0